import { Smartphone, BatteryWarning, Droplets, Unplug } from "lucide-react";
import { Reveal, SectionHead } from "@/components/Reveal";

const PAIRS = [
  { icon: Smartphone, problem: "Écran brisé", solution: "Remplacement d'écran qualité, souvent en 30 minutes." },
  { icon: BatteryWarning, problem: "Batterie qui s'effondre", solution: "Batterie neuve testée, capacité d'origine, garantie 1 an." },
  { icon: Droplets, problem: "Chute dans l'eau, oxydation", solution: "Bain ultrasons + micro-soudure de précision sur la carte." },
  { icon: Unplug, problem: "Appareil bloqué, lent, qui chauffe", solution: "Diagnostic complet : système, SSD, RAM, refroidissement." },
];

export default function ProblemSolution() {
  return (
    <section id="probleme" className="py-24 lg:py-32">
      <div className="mx-auto w-full max-w-7xl px-5 lg:px-8">
        <SectionHead
          tag="Le constat"
          title={<>Une panne n'est pas <span className="text-neon">une fatalité</span></>}
          sub="Remplacer coûte cher — pour votre portefeuille comme pour la planète. Chez MAXREVIX, chaque panne a sa solution, expliquée et chiffrée avant l'intervention."
        />

        <div className="mt-14 grid gap-4">
          {PAIRS.map((p, i) => (
            <Reveal key={p.problem} delay={i * 0.08}>
              <div className="group grid items-center gap-4 rounded-2xl border border-line bg-ink p-5 transition-colors duration-300 hover:border-neon/40 sm:grid-cols-[1fr_auto_1fr] sm:p-6">
                <div className="flex items-center gap-4">
                  <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl border border-red-400/25 bg-red-400/10 text-red-400">
                    <p.icon size={22} />
                  </span>
                  <div>
                    <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-red-400">Problème</p>
                    <p className="mt-0.5 font-display text-xl font-bold uppercase tracking-tight text-white">{p.problem}</p>
                  </div>
                </div>

                <span className="hidden h-10 w-10 items-center justify-center rounded-full border border-line text-slate-500 transition-all duration-300 group-hover:border-neon/50 group-hover:text-neon sm:flex">
                  <span aria-hidden="true" className="text-lg font-bold leading-none text-neon">→</span>
                </span>
                <span className="h-10 w-10 rotate-90 items-center justify-center rounded-full border border-line text-slate-500 transition-all duration-300 group-hover:border-neon/50 group-hover:text-neon sm:hidden flex">
                  <span aria-hidden="true" className="text-lg font-bold leading-none text-neon">→</span>
                </span>

                <div className="flex items-center gap-4 rounded-xl border border-neon/20 bg-neon/5 p-4">
                  <div>
                    <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-neon">Chez MAXREVIX</p>
                    <p className="mt-0.5 text-sm font-semibold leading-snug text-white">{p.solution}</p>
                  </div>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
